"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeToSpeaking = exports.DSRolesToSpeaking = exports.DSRoles = exports.DSType = void 0;
exports.DSType = {
    S3: 's3',
    Cassandra: 'cassandra',
};
exports.DSRoles = {
    DefaultCassandra: 'default_cassandra',
    HostMount: 'host_mount',
    RGW: 'rgw',
};
exports.DSRolesToSpeaking = {
    default_cassandra: 'Default Cassandra',
    host_mount: 'Host Mount MinIO',
    rgw: 'Ceph Rados Gateway',
};
function typeToSpeaking(type) {
    switch (type) {
        case 'cassandra':
            return 'Apache Cassandra';
        case 's3':
            return 'S3 Object Storage';
        default:
            return type;
    }
}
exports.typeToSpeaking = typeToSpeaking;
//# sourceMappingURL=dataSource.js.map